<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Dropdown from "@/dsComponents/Dropdown/Dropdown.vue";

interface WorkerAbortReasonTooltipProps {
    date: string;
    reason: string;
}

defineProps<WorkerAbortReasonTooltipProps>();

const { t } = useI18n();
</script>

<template>
    <Dropdown mode="hover" width="fit-content" :styles="{padding: 'var(--spacing-md, 8px)'}">
        <template #trigger-zone>
            <span class="worker-abort-reason-tooltip-trigger lastupdate-cell">{{ date }}</span>
        </template>
        <template #dropdown-content>
            <div class="worker-abort-reason-tooltip-popover">
                <span class="typo-xxs-regular worker-abort-reason-tooltip-label">
                    {{ t("page.companyNeed.missions.abortReasonLabel") }}
                </span>
                <span class="typo-xs-regular worker-abort-reason-tooltip-reason">{{ reason }}</span>
            </div>
        </template>
    </Dropdown>
</template>

<style scoped lang="scss">
.worker-abort-reason-tooltip-trigger {
    color: var(--text-sub-600, #4c505e);
}

.worker-abort-reason-tooltip-popover {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 8px);
}

.worker-abort-reason-tooltip-label {
    color: var(--text-sub-600, #494e61);
}

.worker-abort-reason-tooltip-reason {
    color: var(--text-main-900, #00061a);
}
</style>
